import { RootState } from "domain/store";

export const selectOnBoardingValues = (state: RootState) => {
  return state.onBoarding;
};
